import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const path = window.location.pathname;
    const url = error?.config?.url || "";
    if (error?.response?.status === 401 && path.startsWith("/admin") && path !== "/admin/login") {
      if (!url.includes("/auth/me")) {
        try { sessionStorage.setItem("beg_session_expired", "1"); } catch (e) { console.debug("session flag skipped", e); }
      }
      window.location.assign("/admin/login");
    }
    return Promise.reject(error);
  }
);

// Resolve any stored media path to the CURRENT backend so uploaded images load
// on every environment (preview + production). External URLs pass through.
export function mediaUrl(u) {
  if (!u) return u;
  if (u.startsWith("/")) return `${BACKEND_URL}${u}`;
  const m = u.match(/\/api\/files\/.*/);
  if (m) return `${BACKEND_URL}${m[0]}`;
  return u;
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Une erreur est survenue.";
}
